export default () => ({
  wordpressUrl: 'https://wordpress.kevynhale.com/graphql',
  internalAppUrl: 'https://api.kevynhale.com',
});
